function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 240,
  r: 240,
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 480,
  height: 480
}, /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 240,
  r: 240,
  fill: "url(#paint1_linear)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M160.933 180.329C158.794 177.881 156.16 176.654 153.025 176.654H88.9209C88.3516 176.654 87.8857 176.474 87.5349 176.114C87.1783 175.759 87 175.358 87 174.928V131.727C87 131.296 87.1783 130.901 87.5349 130.541C87.8857 130.18 88.3516 130 88.9209 130H156.66C173.753 130 188.5 136.988 200.894 150.952L217.348 171.038L185.296 210.135L160.933 180.329ZM279.319 150.737C291.713 136.912 306.529 130 323.765 130H391.292C391.861 130 392.287 130.145 392.574 130.43C392.856 130.721 393 131.151 393 131.727V174.928C393 175.358 392.856 175.759 392.574 176.114C392.287 176.474 391.861 176.654 391.292 176.654H327.187C324.053 176.654 321.419 177.881 319.279 180.329L272.055 237.785L319.492 295.671C321.632 297.979 324.191 299.13 327.187 299.13H391.292C391.861 299.13 392.287 299.311 392.574 299.671C392.856 300.032 393 300.502 393 301.072V344.273C393 344.704 392.856 345.105 392.574 345.459C392.287 345.82 391.861 346 391.292 346H323.765C306.529 346 291.782 339.018 279.532 325.048L240.216 277.097L200.894 325.048C188.5 339.018 173.684 346 156.447 346H88.9209C88.3516 346 87.9202 345.82 87.6384 345.459C87.3508 345.099 87.2128 344.634 87.2128 344.052V300.851C87.2128 300.421 87.3508 300.026 87.6384 299.665C87.9202 299.305 88.3516 299.125 88.9209 299.125H153.025C156.016 299.125 158.65 297.904 160.933 295.45L207.301 238.86L279.319 150.737Z",
  fill: "#00D1FF"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 240,
  y1: 0,
  x2: 240,
  y2: 701.818,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#08021E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1F0777"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 240,
  y1: 0,
  x2: 240,
  y2: 701.818,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#08021E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1F0777"
})));

var SvgSnx = function SvgSnx(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 480,
    viewBox: "0 0 480 480",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSnx, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SNX.5300c159.svg";
export { ForwardRef as ReactComponent };